export { SectionComparisonTable } from './SectionComparisonTable';
export type { Table, Row } from './SectionComparisonTable';
